var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallClock = function SvgWallClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5C7082",
    clipPath: "url(#wall-clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.744 8.922a.47.47 0 0 0-.656.097 5 5 0 0 1-.27.333.469.469 0 0 0 .702.62q.169-.19.32-.394a.47.47 0 0 0-.096-.656M11.528 6.724a.47.47 0 0 0-.558.358q-.046.21-.109.414a.469.469 0 0 0 .896.277q.075-.242.13-.492a.47.47 0 0 0-.36-.557M8.488 10.423q-.188.106-.383.193a.469.469 0 1 0 .386.855q.23-.105.454-.23a.469.469 0 1 0-.457-.818M5.531 2.25v3.556L3.812 7.525a.469.469 0 0 0 .663.663L6.331 6.33A.47.47 0 0 0 6.47 6V2.25a.469.469 0 1 0-.938 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 1.008a.47.47 0 0 0-.469.469v1.301A6.01 6.01 0 0 0 6 0a5.96 5.96 0 0 0-4.243 1.757A5.96 5.96 0 0 0 0 6c0 1.603.624 3.11 1.757 4.243A5.96 5.96 0 0 0 6 12h.023q.255 0 .508-.021a.469.469 0 0 0-.079-.934 5 5 0 0 1-.429.018H6A5.07 5.07 0 0 1 .938 6 5.07 5.07 0 0 1 6 .938c1.799 0 3.454.958 4.358 2.484H9.069a.469.469 0 1 0 0 .937H10.5a1.5 1.5 0 0 0 .822-.246A1.5 1.5 0 0 0 12 2.86V1.477a.47.47 0 0 0-.469-.47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wall-clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgWallClock;